/**
 * CatCompanion — 猫咪侧影动画组件
 *
 * 深色背影 + 磷光外发光，三层独立动画：
 *   1. 尾巴 3-4s 摆动
 *   2. 眨眼 5-6s
 *   3. 耳朵 7-8s 微动
 */

const MOOD_COLORS = {
  idle: { glow: '#60a5fa', body: '#1e293b' },
  curious: { glow: '#a78bfa', body: '#312e81' },
  sleepy: { glow: '#818cf8', body: '#1e1b4b' },
  happy: { glow: '#34d399', body: '#064e3b' },
}

export default function CatCompanion({
  size = 120,
  mood = 'idle',
  className = '',
  style = {},
}) {
  const { glow, body } = MOOD_COLORS[mood] || MOOD_COLORS.idle

  return (
    <>
      <style>{`
        @keyframes cat-tail-wag {
          0%, 100% { transform: rotate(-8deg); }
          50% { transform: rotate(12deg); }
        }
        @keyframes cat-blink {
          0%, 92%, 100% { transform: scaleY(1); }
          95%, 97% { transform: scaleY(0.1); }
        }
        @keyframes cat-ear-twitch {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-5deg); }
          75% { transform: rotate(4deg); }
        }
        @keyframes cat-float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-4px); }
        }
      `}</style>

      <div
        className={`inline-block ${className}`}
        style={{
          width: size,
          height: size,
          position: 'relative',
          boxShadow: `0 0 32px 8px ${glow}44, 0 0 64px 16px ${glow}22`,
          borderRadius: '50%',
          ...style,
        }}
      >
        <svg
          viewBox="0 0 100 100"
          width={size}
          height={size}
          xmlns="http://www.w3.org/2000/svg"
          style={{ position: 'absolute', inset: 0 }}
        >
          {/* 整体浮动容器 */}
          <g style={{ animation: 'cat-float 4s ease-in-out infinite', transformOrigin: 'center' }}>
            {/* 猫身 — 侧影 */}
            <ellipse cx="50" cy="62" rx="28" ry="20" fill={body} />
            {/* 猫头 */}
            <circle cx="50" cy="40" r="16" fill={body} />

            {/* 左耳 — 微动 7-8s */}
            <g style={{ animation: 'cat-ear-twitch 7.5s ease-in-out infinite', transformOrigin: '40px 30px' }}>
              <path d="M36 28 L32 12 L44 22 Z" fill={body} />
            </g>
            {/* 右耳 */}
            <g style={{ animation: 'cat-ear-twitch 7.5s ease-in-out 0.3s infinite', transformOrigin: '58px 28px' }}>
              <path d="M64 28 L68 12 L56 22 Z" fill={body} />
            </g>

            {/* 左眼 — 眨眼 5-6s */}
            <g style={{ animation: 'cat-blink 5.5s ease-in-out infinite', transformOrigin: '44px 38px' }}>
              <ellipse cx="44" cy="38" rx="2.5" ry="3" fill={glow} />
            </g>
            {/* 右眼 */}
            <g style={{ animation: 'cat-blink 5.5s ease-in-out infinite', transformOrigin: '56px 38px' }}>
              <ellipse cx="56" cy="38" rx="2.5" ry="3" fill={glow} />
            </g>

            {/* 鼻子 */}
            <path d="M48 44 L50 46 L52 44 Z" fill={glow} opacity="0.7" />

            {/* 尾巴 — 摆动 3-4s */}
            <g style={{ animation: 'cat-tail-wag 3.5s ease-in-out infinite', transformOrigin: '76px 62px' }}>
              <path
                d="M76 62 Q90 50 88 36 Q86 28 80 30"
                fill="none"
                stroke={body}
                strokeWidth="5"
                strokeLinecap="round"
              />
            </g>

            {/* 胡须 */}
            <line x1="28" y1="42" x2="38" y2="43" stroke={glow} strokeWidth="0.5" opacity="0.5" />
            <line x1="28" y1="46" x2="38" y2="46" stroke={glow} strokeWidth="0.5" opacity="0.5" />
            <line x1="62" y1="43" x2="72" y2="42" stroke={glow} strokeWidth="0.5" opacity="0.5" />
            <line x1="62" y1="46" x2="72" y2="46" stroke={glow} strokeWidth="0.5" opacity="0.5" />
          </g>
        </svg>
      </div>
    </>
  )
}
